import React, { Component } from "react";
import { Card, Col, Row, Form, Button, Table } from "react-bootstrap-v5";
import { toast } from "react-toastify";
import ReactToPrint from "react-to-print";
import moment from "moment";
import {Spinner} from "react-bootstrap-v5";
import { reportService } from "../../Services/reportService";
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;

class AddOns extends Component {
  state = {
    reportObj: [],
    startDate: "",
    endDate: "",
    service: "",
    loader:false
  };

  componentDidMount() {
    this.componentRef = React.createRef();
    this.getAddOns();
  }

  getAddOns = (params = {}) => {
    this.setState({loader:true})
    reportService.getAddOns(params).then((result) => {
      if (result.status === true) {
        console.log(" result.data", result.data);
        this.setState({ reportObj: result.data,loader:false });
      } else {
        toast.info("Something went wrong");
      }
    this.setState({loader:false})
    });
  };

  exportToExcel = () => {
    const params = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      item_name: this.state.service
    }
    reportService.exportAddOns(params).then((result) => {
      if (result.status === true) {
        window.location.href = REACT_APP_API_BASEURL + "/" + result.data;
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  //date selection function //neha

  handleDateChange = (e) => {
    const { name, value } = e.target;
    let setdate = name === "start_date" ? "startDate" : "endDate";

    const selectedDate = new Date(value).getTime();
    this.setState({ [setdate]: selectedDate }, () => {
      const { startDate, endDate } = this.state;

      if (startDate !== "" && endDate !== "") {
        if (startDate > endDate) {
          this.setState({ startDate: "", endDate: "" });
          toast.info("Start date cannot be greater than end date.");

        } else {
          let search = {
            startDate: startDate,
            endDate: endDate,
            item_name: this.state.service,
          };

          this.getAddOns(search);
        }
      }
    });
  };

  //selection of service through dropdown
  handleServicesChange = (e) => {
    this.setState({ service: e.target.value }, () => {
      let search = {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        item_name: this.state.service,
      };
      // console.log("searcg", search);
      this.getAddOns(search);
    });
    console.log("e.target.value", e.target.value);
  };

  render() {
    const { reportObj } = this.state;
    let revTotal = 0,
      costTotal = 0,
      profitTotal = 0;

    return (
      <Card>
        <div className="card-header bg-light">
          <h4>Add Ons</h4>
        </div>
        <Card.Body>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Label>Services</Form.Label>
              <Form.Select
                aria-label="Default select example"
                name="type"
                onChange={(e) => {
                  this.handleServicesChange(e);
                }}
              >
                <option value="">SELECT ALL</option>
                <option value="insurance">INSURANCE</option>
                <option value="storage">STORAGE</option>
                <option value="packing">PACKING</option>
              </Form.Select>
            </Col>
            <Col md={3}>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                max={new Date().toISOString().split('T')[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3}>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                max={new Date().toISOString().split('T')[0]}
                onChange={(e) => this.handleDateChange(e)}
              />
            </Col>
            <Col md={3} className="d-flex justify-content-end mt-3">
              <Button
                className="me-1"
                variant="success"
                onClick={() => this.exportToExcel()}
              >
                Excel
              </Button>
              <ReactToPrint
                trigger={() => {
                  return <Button variant="secondary">Print</Button>;
                }}
                content={() => this.componentRef}
                bodyClass={"printElement m-5"}
              />
            </Col>
          </Row>

          <Row className="printElement" ref={(el) => (this.componentRef = el)}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Add Ons</th>
                  <th>Job number</th>
                  <th>Customer name</th>
                  <th>Date</th>
                  <th>Revenue</th>
                  <th>Cost</th>
                  <th>Profit</th>
                  <th>Profit(%)</th>
                </tr>
              </thead>
              {/* <tbody>
                {reportObj.length &&
                  reportObj.map((item, index) => {
                    if (item.costs) {
                      let addOnType = item.costs.cost_item_name;
                      let revenueType =
                        item.invoices &&
                        item.invoices.filter(
                          (type) => type.item.item_name === addOnType
                        );

                      let rev = revenueType
                        ? revenueType.length && revenueType[0].glc_amount
                        : 0;
                      let cost = item.costs.gross_amount;

                      let profit = rev - cost; // Get Profit
                      let profitPer =
                        profit !== 0 && cost !== 0 ? (profit / cost) * 100 : 0;
                      revTotal = rev + revTotal;
                      costTotal = cost + costTotal;
                      profitTotal = profit + profitTotal;

                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item.costs.cost_item_name}</td>
                          <td>{item.job_token}</td>
                          <td>{rev}</td>
                          <td>{cost}</td>
                          <td>{profit}</td>
                          <td>{profitPer.toFixed(3)}</td>

                          <td>
                            {moment(item.created_at).format("YYYY-MM-DD")}
                          </td>
                        </tr>
                      );
                    }
                    return;
                  })}

                {
                  <tr>
                    <td colSpan={3}>
                      <strong>Total</strong>
                    </td>
                    <td>{revTotal}</td>
                    <td>{costTotal}</td>
                    <td>{profitTotal}</td>
                    <td></td>
                  </tr>
                }
              </tbody> */}
               {this.state.loader &&
                    <tbody>
                        <tr>
                            <td colSpan={20} className='text-center'>
                        <Spinner animation="border" />
                            </td>
                        </tr>
                    </tbody> 
                  ||

              <tbody>
                {reportObj &&
                  reportObj.length &&
                  reportObj.map((item, index) => {
                    if (item?.costs?.cost_item_name === item?.invoices?.item?.item_name) {
                      if (
                        item?.invoices?.item?.item_name === "insurance" ||
                        item?.invoices?.item?.item_name === "storage" ||
                        item?.invoices?.item?.item_name === "packing"
                      ) {
                        if (item.costs) {
                          let addOnType = item.costs.cost_item_name;

                          const result = Object.keys(item.invoices).map(
                            (key) => item.invoices[key]
                          );

                          let revenueType =
                            result &&
                            result.filter((type) => type.item_name === addOnType);

                          let rev = revenueType
                            ? revenueType.length && revenueType[0].lc_amount
                            : 0;

                          let cost = item.costs.lc_amount;

                          let profit = rev - cost; // Get Profit
                          let profitPer =
                            profit !== 0 && cost !== 0
                              ? (profit / cost) * 100
                              : 0;
                          revTotal = rev + revTotal;
                          costTotal = cost + costTotal;
                          profitTotal = profit + profitTotal;

                          return (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item.invoices.item.item_name}</td>
                              <td>{item.job_token}</td>
                              <td>{item?.customer_details?.name || "-"}</td>
                              <td>{moment(item.created_at).format("DD-MM-YYYY")}</td>
                              <td>{rev.toFixed(2)}</td>
                              <td>{cost.toFixed(2)}</td>
                              <td>{profit.toFixed(2)}</td>
                              <td>{profitPer.toFixed(2)}</td>
                            </tr>
                          );
                        }
                      }
                    }
                  }) || <tr><td colSpan={20} className='text-center'>Data Not Found</td></tr>
                }
                {
                  <tr>
                    <td colSpan={4}>
                      <strong>Total</strong>
                    </td>
                    <td>{revTotal.toFixed(2)}</td>
                    <td>{costTotal.toFixed(2)}</td>
                    <td>{profitTotal.toFixed(2)}</td>
                    <td></td>
                    <td></td>
                  </tr>
                }
              </tbody>}
            </Table>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export { AddOns };
